module.exports = __webpack_public_path__ + "img/shipping-cost.81e80725.png";